// Import of default plugins
define('components/nav/navigation-bundle.std',[
  './navigation.mobile',
  './navigation.vehicles',
  './navigation.zip',
  './navigation.analytics',
  './navigation.favorites',
  './navigation.gxp',
  './images.lazyload'
], function () {});

